import React from 'react';
import { createRoot } from 'react-dom/client';
import 'focus-visible/dist/focus-visible.js';
import { datadogRum } from '@datadog/browser-rum';
import { credentials } from 'lib/dataDog';
import Root from 'components/Root.jsx';

datadogRum.init({
    applicationId: credentials.applicationId,
    clientToken: credentials.clientToken,
    // `site` refers to the Datadog site parameter of your organization
    // see https://docs.datadoghq.com/getting_started/site/
    site: 'datadoghq.com',
    service: 'unified-lead-flow',
    env: '<ENV_NAME>',
    // Specify a version number to identify the deployed version of your application in Datadog
    // version: '1.0.0',
    sessionSampleRate: 100,
    sessionReplaySampleRate: 20,
    defaultPrivacyLevel: 'mask-user-input',
});

const root = createRoot(document.getElementById('root'));

// When the document has been completely loaded, re-render w/out loader content
window.addEventListener('load', function (event) {
  if (event.target.readyState === 'complete') {
    root.render(<Root />);
  }
});
